import TradePartner from 'umg-ember-backend/components/record-explorer/for/trade-partner';

<template>
  <TradePartner @records={{@model}} @recordType='trade-partner' />
</template>
